export const EDITOR_CREATE_PAGE_BEGIN = 'EDITOR_CREATE_PAGE_BEGIN';
export const EDITOR_CREATE_PAGE_SUCCESS = 'EDITOR_CREATE_PAGE_SUCCESS';
export const EDITOR_CREATE_PAGE_FAILURE = 'EDITOR_CREATE_PAGE_FAILURE';
export const EDITOR_CREATE_PAGE_DISMISS_ERROR = 'EDITOR_CREATE_PAGE_DISMISS_ERROR';
export const EDITOR_LOAD_PAGES_BEGIN = 'EDITOR_LOAD_PAGES_BEGIN';
export const EDITOR_LOAD_PAGES_SUCCESS = 'EDITOR_LOAD_PAGES_SUCCESS';
export const EDITOR_LOAD_PAGES_FAILURE = 'EDITOR_LOAD_PAGES_FAILURE';
export const EDITOR_LOAD_PAGES_DISMISS_ERROR = 'EDITOR_LOAD_PAGES_DISMISS_ERROR';
export const EDITOR_LOAD_COLLECTIONS_BEGIN = 'EDITOR_LOAD_COLLECTIONS_BEGIN';
export const EDITOR_LOAD_COLLECTIONS_SUCCESS = 'EDITOR_LOAD_COLLECTIONS_SUCCESS';
export const EDITOR_LOAD_COLLECTIONS_FAILURE = 'EDITOR_LOAD_COLLECTIONS_FAILURE';
export const EDITOR_LOAD_COLLECTIONS_DISMISS_ERROR = 'EDITOR_LOAD_COLLECTIONS_DISMISS_ERROR';
export const EDITOR_CREATE_COLLECTION_BEGIN = 'EDITOR_CREATE_COLLECTION_BEGIN';
export const EDITOR_CREATE_COLLECTION_SUCCESS = 'EDITOR_CREATE_COLLECTION_SUCCESS';
export const EDITOR_CREATE_COLLECTION_FAILURE = 'EDITOR_CREATE_COLLECTION_FAILURE';
export const EDITOR_CREATE_COLLECTION_DISMISS_ERROR = 'EDITOR_CREATE_COLLECTION_DISMISS_ERROR';
export const EDITOR_CREATE_NEW_COLLECTION = 'EDITOR_CREATE_NEW_COLLECTION';
export const EDITOR_ADD_NEW_FIELD = 'EDITOR_ADD_NEW_FIELD';
export const EDITOR_COLLECTION_SETTING = 'EDITOR_COLLECTION_SETTING';
export const EDITOR_UPDATE_COLLECTION = 'EDITOR_UPDATE_COLLECTION';
export const EDITOR_UPDATE_COLLECTIONS_BEGIN = 'EDITOR_UPDATE_COLLECTIONS_BEGIN';
export const EDITOR_UPDATE_COLLECTIONS_SUCCESS = 'EDITOR_UPDATE_COLLECTIONS_SUCCESS';
export const EDITOR_UPDATE_COLLECTIONS_FAILURE = 'EDITOR_UPDATE_COLLECTIONS_FAILURE';
export const EDITOR_UPDATE_COLLECTIONS_DISMISS_ERROR = 'EDITOR_UPDATE_COLLECTIONS_DISMISS_ERROR';
export const EDITOR_UPDATE_FIELD = 'EDITOR_UPDATE_FIELD';
export const EDITOR_DELETE_COLLECTION_BEGIN = 'EDITOR_DELETE_COLLECTION_BEGIN';
export const EDITOR_DELETE_COLLECTION_SUCCESS = 'EDITOR_DELETE_COLLECTION_SUCCESS';
export const EDITOR_DELETE_COLLECTION_FAILURE = 'EDITOR_DELETE_COLLECTION_FAILURE';
export const EDITOR_DELETE_COLLECTION_DISMISS_ERROR = 'EDITOR_DELETE_COLLECTION_DISMISS_ERROR';
export const EDITOR_OPEN_ITEM_PAGE = 'EDITOR_OPEN_ITEM_PAGE';
export const EDITOR_LOAD_COLLECTION_ITEMS_BEGIN = 'EDITOR_LOAD_COLLECTION_ITEMS_BEGIN';
export const EDITOR_LOAD_COLLECTION_ITEMS_SUCCESS = 'EDITOR_LOAD_COLLECTION_ITEMS_SUCCESS';
export const EDITOR_LOAD_COLLECTION_ITEMS_FAILURE = 'EDITOR_LOAD_COLLECTION_ITEMS_FAILURE';
export const EDITOR_LOAD_COLLECTION_ITEMS_DISMISS_ERROR =
  'EDITOR_LOAD_COLLECTION_ITEMS_DISMISS_ERROR';
export const EDITOR_SAVE_NEW_ITEM_BEGIN = 'EDITOR_SAVE_NEW_ITEM_BEGIN';
export const EDITOR_SAVE_NEW_ITEM_SUCCESS = 'EDITOR_SAVE_NEW_ITEM_SUCCESS';
export const EDITOR_SAVE_NEW_ITEM_FAILURE = 'EDITOR_SAVE_NEW_ITEM_FAILURE';
export const EDITOR_SAVE_NEW_ITEM_DISMISS_ERROR = 'EDITOR_SAVE_NEW_ITEM_DISMISS_ERROR';
export const EDITOR_OPEN_NEW_ITEM_FORM = 'EDITOR_OPEN_NEW_ITEM_FORM';
export const EDITOR_OPEN_EDIT_ITEM_FORM = 'EDITOR_OPEN_EDIT_ITEM_FORM';
export const EDITOR_CLOSE_ITEM_LIST_PAGE = 'EDITOR_CLOSE_ITEM_LIST_PAGE';
export const EDITOR_CLOSE_ITEM_FORM = 'EDITOR_CLOSE_ITEM_FORM';
export const EDITOR_CLOSE_COLLECTION_SETTING_PAGE = 'EDITOR_CLOSE_COLLECTION_SETTING_PAGE';
export const EDITOR_UPDATE_ITEM_BEGIN = 'EDITOR_UPDATE_ITEM_BEGIN';
export const EDITOR_UPDATE_ITEM_SUCCESS = 'EDITOR_UPDATE_ITEM_SUCCESS';
export const EDITOR_UPDATE_ITEM_FAILURE = 'EDITOR_UPDATE_ITEM_FAILURE';
export const EDITOR_UPDATE_ITEM_DISMISS_ERROR = 'EDITOR_UPDATE_ITEM_DISMISS_ERROR';
export const EDITOR_SAVE_FIELD = 'EDITOR_SAVE_FIELD';
export const EDITOR_TOGGLE_CREATE_PAGE = 'EDITOR_TOGGLE_CREATE_PAGE';
export const EDITOR_TOGGLE_EMAIL_SETTING = 'EDITOR_TOGGLE_EMAIL_SETTING';
export const EDITOR_TOGGLE_SIDEBAR = 'EDITOR_TOGGLE_SIDEBAR';
export const EDITOR_TOGGLE_PAGE_MODAL = 'EDITOR_TOGGLE_PAGE_MODAL';
export const EDITOR_TOGGLE_COLLECTION_MODAL = 'EDITOR_TOGGLE_COLLECTION_MODAL';
export const EDITOR_TOGGLE_TEMPLATE_MODAL = 'EDITOR_TOGGLE_TEMPLATE_MODAL';
export const EDITOR_LOAD_PROJECT_BEGIN = 'EDITOR_LOAD_PROJECT_BEGIN';
export const EDITOR_LOAD_PROJECT_SUCCESS = 'EDITOR_LOAD_PROJECT_SUCCESS';
export const EDITOR_LOAD_PROJECT_FAILURE = 'EDITOR_LOAD_PROJECT_FAILURE';
export const EDITOR_LOAD_PROJECT_DISMISS_ERROR = 'EDITOR_LOAD_PROJECT_DISMISS_ERROR';
export const EDITOR_LOAD_INSTALLED_PLUGINS_BEGIN = 'EDITOR_LOAD_INSTALLED_PLUGINS_BEGIN';
export const EDITOR_LOAD_INSTALLED_PLUGINS_SUCCESS = 'EDITOR_LOAD_INSTALLED_PLUGINS_SUCCESS';
export const EDITOR_LOAD_INSTALLED_PLUGINS_FAILURE = 'EDITOR_LOAD_INSTALLED_PLUGINS_FAILURE';
export const EDITOR_LOAD_INSTALLED_PLUGINS_DISMISS_ERROR =
  'EDITOR_LOAD_INSTALLED_PLUGINS_DISMISS_ERROR';
export const EDITOR_UPDATE_PAGE_BEGIN = 'EDITOR_UPDATE_PAGE_BEGIN';
export const EDITOR_UPDATE_PAGE_SUCCESS = 'EDITOR_UPDATE_PAGE_SUCCESS';
export const EDITOR_UPDATE_PAGE_FAILURE = 'EDITOR_UPDATE_PAGE_FAILURE';
export const EDITOR_UPDATE_PAGE_DISMISS_ERROR = 'EDITOR_UPDATE_PAGE_DISMISS_ERROR';
export const EDITOR_CREATE_SNIPPET_TEMPLATE_BEGIN = 'EDITOR_CREATE_SNIPPET_TEMPLATE_BEGIN';
export const EDITOR_CREATE_SNIPPET_TEMPLATE_SUCCESS = 'EDITOR_CREATE_SNIPPET_TEMPLATE_SUCCESS';
export const EDITOR_CREATE_SNIPPET_TEMPLATE_DISMISS_ERROR =
  'EDITOR_CREATE_SNIPPET_TEMPLATE_DISMISS_ERROR';
export const EDITOR_CREATE_SNIPPET_TEMPLATE_FAILURE = 'EDITOR_CREATE_SNIPPET_TEMPLATE_FAILURE';
export const EDITOR_ADD_UTILITY_FUNCTION_TO_COLLECTION_BEGIN =
  'EDITOR_ADD_UTILITY_FUNCTION_TO_COLLECTION_BEGIN';
export const EDITOR_ADD_UTILITY_FUNCTION_TO_COLLECTION_SUCCESS =
  'EDITOR_ADD_UTILITY_FUNCTION_TO_COLLECTION_SUCCESS';
export const EDITOR_ADD_UTILITY_FUNCTION_TO_COLLECTION_FAILURE =
  'EDITOR_ADD_UTILITY_FUNCTION_TO_COLLECTION_FAILURE';
export const EDITOR_ADD_UTILITY_FUNCTION_TO_COLLECTION_DISMISS_ERROR =
  'EDITOR_ADD_UTILITY_FUNCTION_TO_COLLECTION_DISMISS_ERROR';
export const EDITOR_TOGGLE_REST_API_RESPONSE = 'EDITOR_TOGGLE_REST_API_RESPONSE';
export const EDITOR_LOAD_SNIPPETS_BEGIN = 'EDITOR_LOAD_SNIPPETS_BEGIN';
export const EDITOR_LOAD_SNIPPETS_SUCCESS = 'EDITOR_LOAD_SNIPPETS_SUCCESS';
export const EDITOR_LOAD_SNIPPETS_FAILURE = 'EDITOR_LOAD_SNIPPETS_FAILURE';
export const EDITOR_LOAD_SNIPPETS_DISMISS_ERROR = 'EDITOR_LOAD_SNIPPETS_DISMISS_ERROR';
export const EDITOR_TOGGLE_ASSET_UPLOD = 'EDITOR_TOGGLE_ASSET_UPLOD';
export const EDITOR_LOAD_PROJECT_ASSETS_BEGIN = 'EDITOR_LOAD_PROJECT_ASSETS_BEGIN';
export const EDITOR_LOAD_PROJECT_ASSETS_SUCCESS = 'EDITOR_LOAD_PROJECT_ASSETS_SUCCESS';
export const EDITOR_LOAD_PROJECT_ASSETS_FAILURE = 'EDITOR_LOAD_PROJECT_ASSETS_FAILURE';
export const EDITOR_LOAD_PROJECT_ASSETS_DISMISS_ERROR = 'EDITOR_LOAD_PROJECT_ASSETS_DISMISS_ERROR';
export const EDITOR_CREATE_COLLECTION_CONSTANT_BEGIN = 'EDITOR_CREATE_COLLECTION_CONSTANT_BEGIN';
export const EDITOR_CREATE_COLLECTION_CONSTANT_SUCCESS =
  'EDITOR_CREATE_COLLECTION_CONSTANT_SUCCESS';
export const EDITOR_CREATE_COLLECTION_CONSTANT_FAILURE =
  'EDITOR_CREATE_COLLECTION_CONSTANT_FAILURE';
export const EDITOR_CREATE_COLLECTION_CONSTANT_DISMISS_ERROR =
  'EDITOR_CREATE_COLLECTION_CONSTANT_DISMISS_ERROR';
export const EDITOR_ITEM_UPDATE = 'EDITOR_ITEM_UPDATE';
export const EDITOR_SAVE_ITEM = 'EDITOR_SAVE_ITEM';
export const EDITOR_LOAD_DEFAULT_PAGE_BEGIN = 'EDITOR_LOAD_DEFAULT_PAGE_BEGIN';
export const EDITOR_LOAD_DEFAULT_PAGE_SUCCESS = 'EDITOR_LOAD_DEFAULT_PAGE_SUCCESS';
export const EDITOR_LOAD_DEFAULT_PAGE_FAILURE = 'EDITOR_LOAD_DEFAULT_PAGE_FAILURE';
export const EDITOR_LOAD_DEFAULT_PAGE_DISMISS_ERROR = 'EDITOR_LOAD_DEFAULT_PAGE_DISMISS_ERROR';
export const EDITOR_ADD_QUERY_TO_COLLECTION_BEGIN = 'EDITOR_ADD_QUERY_TO_COLLECTION_BEGIN';
export const EDITOR_ADD_QUERY_TO_COLLECTION_SUCCESS = 'EDITOR_ADD_QUERY_TO_COLLECTION_SUCCESS';
export const EDITOR_ADD_QUERY_TO_COLLECTION_FAILURE = 'EDITOR_ADD_QUERY_TO_COLLECTION_FAILURE';
export const EDITOR_ADD_QUERY_TO_COLLECTION_DISMISS_ERROR =
  'EDITOR_ADD_QUERY_TO_COLLECTION_DISMISS_ERROR';
export const EDITOR_CREATE_NEW_FIELD_BEGIN = 'EDITOR_CREATE_NEW_FIELD_BEGIN';
export const EDITOR_CREATE_NEW_FIELD_SUCCESS = 'EDITOR_CREATE_NEW_FIELD_SUCCESS';
export const EDITOR_CREATE_NEW_FIELD_FAILURE = 'EDITOR_CREATE_NEW_FIELD_FAILURE';
export const EDITOR_CREATE_NEW_FIELD_DISMISS_ERROR = 'EDITOR_CREATE_NEW_FIELD_DISMISS_ERROR';
export const EDITOR_DELETE_FIELD_BEGIN = 'EDITOR_DELETE_FIELD_BEGIN';
export const EDITOR_DELETE_FIELD_SUCCESS = 'EDITOR_DELETE_FIELD_SUCCESS';
export const EDITOR_DELETE_FIELD_FAILURE = 'EDITOR_DELETE_FIELD_FAILURE';
export const EDITOR_DELETE_FIELD_DISMISS_ERROR = 'EDITOR_DELETE_FIELD_DISMISS_ERROR';
export const EDITOR_EDIT_FIELD_BEGIN = 'EDITOR_EDIT_FIELD_BEGIN';
export const EDITOR_EDIT_FIELD_SUCCESS = 'EDITOR_EDIT_FIELD_SUCCESS';
export const EDITOR_EDIT_FIELD_FAILURE = 'EDITOR_EDIT_FIELD_FAILURE';
export const EDITOR_EDIT_FIELD_DISMISS_ERROR = 'EDITOR_EDIT_FIELD_DISMISS_ERROR';
export const EDITOR_DELETE_PAGE_BEGIN = 'EDITOR_DELETE_PAGE_BEGIN';
export const EDITOR_DELETE_PAGE_SUCCESS = 'EDITOR_DELETE_PAGE_SUCCESS';
export const EDITOR_DELETE_PAGE_FAILURE = 'EDITOR_DELETE_PAGE_FAILURE';
export const EDITOR_DELETE_PAGE_DISMISS_ERROR = 'EDITOR_DELETE_PAGE_DISMISS_ERROR';
export const EDITOR_FETCH_PAGE_DETAIL_BEGIN = 'EDITOR_FETCH_PAGE_DETAIL_BEGIN';
export const EDITOR_FETCH_PAGE_DETAIL_SUCCESS = 'EDITOR_FETCH_PAGE_DETAIL_SUCCESS';
export const EDITOR_FETCH_PAGE_DETAIL_FAILURE = 'EDITOR_FETCH_PAGE_DETAIL_FAILURE';
export const EDITOR_FETCH_PAGE_DETAIL_DISMISS_ERROR = 'EDITOR_FETCH_PAGE_DETAIL_DISMISS_ERROR';
export const EDITOR_UPDATE_QUERY_OF_COLLECTION_BEGIN = 'EDITOR_UPDATE_QUERY_OF_COLLECTION_BEGIN';
export const EDITOR_UPDATE_QUERY_OF_COLLECTION_SUCCESS =
  'EDITOR_UPDATE_QUERY_OF_COLLECTION_SUCCESS';
export const EDITOR_UPDATE_QUERY_OF_COLLECTION_FAILURE =
  'EDITOR_UPDATE_QUERY_OF_COLLECTION_FAILURE';
export const EDITOR_UPDATE_QUERY_OF_COLLECTION_DISMISS_ERROR =
  'EDITOR_UPDATE_QUERY_OF_COLLECTION_DISMISS_ERROR';
export const EDITOR_UPDATE_CONSTANT_OF_COLLECTION_BEGIN =
  'EDITOR_UPDATE_CONSTANT_OF_COLLECTION_BEGIN';
export const EDITOR_UPDATE_CONSTANT_OF_COLLECTION_SUCCESS =
  'EDITOR_UPDATE_CONSTANT_OF_COLLECTION_SUCCESS';
export const EDITOR_UPDATE_CONSTANT_OF_COLLECTION_FAILURE =
  'EDITOR_UPDATE_CONSTANT_OF_COLLECTION_FAILURE';
export const EDITOR_UPDATE_CONSTANT_OF_COLLECTION_DISMISS_ERROR =
  'EDITOR_UPDATE_CONSTANT_OF_COLLECTION_DISMISS_ERROR';
export const EDITOR_CREATE_PAGE_SNAPSHOT_BEGIN = 'EDITOR_CREATE_PAGE_SNAPSHOT_BEGIN';
export const EDITOR_CREATE_PAGE_SNAPSHOT_SUCCESS = 'EDITOR_CREATE_PAGE_SNAPSHOT_SUCCESS';
export const EDITOR_CREATE_PAGE_SNAPSHOT_FAILURE = 'EDITOR_CREATE_PAGE_SNAPSHOT_FAILURE';
export const EDITOR_CREATE_PAGE_SNAPSHOT_DISMISS_ERROR =
  'EDITOR_CREATE_PAGE_SNAPSHOT_DISMISS_ERROR';
export const EDITOR_LOAD_PAGE_SNAPSHOTS_BEGIN = 'EDITOR_LOAD_PAGE_SNAPSHOTS_BEGIN';
export const EDITOR_LOAD_PAGE_SNAPSHOTS_SUCCESS = 'EDITOR_LOAD_PAGE_SNAPSHOTS_SUCCESS';
export const EDITOR_LOAD_PAGE_SNAPSHOTS_FAILURE = 'EDITOR_LOAD_PAGE_SNAPSHOTS_FAILURE';
export const EDITOR_LOAD_PAGE_SNAPSHOTS_DISMISS_ERROR = 'EDITOR_LOAD_PAGE_SNAPSHOTS_DISMISS_ERROR';
export const EDITOR_TOGGLE_ASSET_SEARCH = 'EDITOR_TOGGLE_ASSET_SEARCH';
export const EDITOR_UPLOD_SEARCHED_IMAGE_BEGIN = 'EDITOR_UPLOD_SEARCHED_IMAGE_BEGIN';
export const EDITOR_UPLOD_SEARCHED_IMAGE_SUCCESS = 'EDITOR_UPLOD_SEARCHED_IMAGE_SUCCESS';
export const EDITOR_UPLOD_SEARCHED_IMAGE_FAILURE = 'EDITOR_UPLOD_SEARCHED_IMAGE_FAILURE';
export const EDITOR_UPLOD_SEARCHED_IMAGE_DISMISS_ERROR =
  'EDITOR_UPLOD_SEARCHED_IMAGE_DISMISS_ERROR';
export const EDITOR_CREATE_COLLECTION_CONSTRUCTOR_BEGIN =
  'EDITOR_CREATE_COLLECTION_CONSTRUCTOR_BEGIN';
export const EDITOR_CREATE_COLLECTION_CONSTRUCTOR_SUCCESS =
  'EDITOR_CREATE_COLLECTION_CONSTRUCTOR_SUCCESS';
export const EDITOR_CREATE_COLLECTION_CONSTRUCTOR_FAILURE =
  'EDITOR_CREATE_COLLECTION_CONSTRUCTOR_FAILURE';
export const EDITOR_CREATE_COLLECTION_CONSTRUCTOR_DISMISS_ERROR =
  'EDITOR_CREATE_COLLECTION_CONSTRUCTOR_DISMISS_ERROR';
export const EDITOR_DELETE_ITEM_BEGIN = 'EDITOR_DELETE_ITEM_BEGIN';
export const EDITOR_DELETE_ITEM_SUCCESS = 'EDITOR_DELETE_ITEM_SUCCESS';
export const EDITOR_DELETE_ITEM_FAILURE = 'EDITOR_DELETE_ITEM_FAILURE';
export const EDITOR_DELETE_ITEM_DISMISS_ERROR = 'EDITOR_DELETE_ITEM_DISMISS_ERROR';
export const EDITOR_DELETE_UITILITY_FUNCTION_BEGIN = 'EDITOR_DELETE_UITILITY_FUNCTION_BEGIN';
export const EDITOR_DELETE_UITILITY_FUNCTION_SUCCESS = 'EDITOR_DELETE_UITILITY_FUNCTION_SUCCESS';
export const EDITOR_DELETE_UITILITY_FUNCTION_FAILURE = 'EDITOR_DELETE_UITILITY_FUNCTION_FAILURE';
export const EDITOR_DELETE_UITILITY_FUNCTION_DISMISS_ERROR =
  'EDITOR_DELETE_UITILITY_FUNCTION_DISMISS_ERROR';
export const EDITOR_DELETE_CONSTRUCTOR_BEGIN = 'EDITOR_DELETE_CONSTRUCTOR_BEGIN';
export const EDITOR_DELETE_CONSTRUCTOR_SUCCESS = 'EDITOR_DELETE_CONSTRUCTOR_SUCCESS';
export const EDITOR_DELETE_CONSTRUCTOR_FAILURE = 'EDITOR_DELETE_CONSTRUCTOR_FAILURE';
export const EDITOR_DELETE_CONSTRUCTOR_DISMISS_ERROR = 'EDITOR_DELETE_CONSTRUCTOR_DISMISS_ERROR';
export const EDITOR_DELETE_COLLECTION_CONSTANT_BEGIN = 'EDITOR_DELETE_COLLECTION_CONSTANT_BEGIN';
export const EDITOR_DELETE_COLLECTION_CONSTANT_SUCCESS =
  'EDITOR_DELETE_COLLECTION_CONSTANT_SUCCESS';
export const EDITOR_DELETE_COLLECTION_CONSTANT_FAILURE =
  'EDITOR_DELETE_COLLECTION_CONSTANT_FAILURE';
export const EDITOR_DELETE_COLLECTION_CONSTANT_DISMISS_ERROR =
  'EDITOR_DELETE_COLLECTION_CONSTANT_DISMISS_ERROR';
export const EDITOR_DELETE_COLLECTION_QUERY_BEGIN = 'EDITOR_DELETE_COLLECTION_QUERY_BEGIN';
export const EDITOR_DELETE_COLLECTION_QUERY_SUCCESS = 'EDITOR_DELETE_COLLECTION_QUERY_SUCCESS';
export const EDITOR_DELETE_COLLECTION_QUERY_FAILURE = 'EDITOR_DELETE_COLLECTION_QUERY_FAILURE';
export const EDITOR_DELETE_COLLECTION_QUERY_DISMISS_ERROR =
  'EDITOR_DELETE_COLLECTION_QUERY_DISMISS_ERROR';
export const EDITOR_SAVE_COLLECTION_ITEM_BEGIN = 'EDITOR_SAVE_COLLECTION_ITEM_BEGIN';
export const EDITOR_SAVE_COLLECTION_ITEM_SUCCESS = 'EDITOR_SAVE_COLLECTION_ITEM_SUCCESS';
export const EDITOR_SAVE_COLLECTION_ITEM_FAILURE = 'EDITOR_SAVE_COLLECTION_ITEM_FAILURE';
export const EDITOR_SAVE_COLLECTION_ITEM_DISMISS_ERROR =
  'EDITOR_SAVE_COLLECTION_ITEM_DISMISS_ERROR';
export const EDITOR_UPDATE_COLLECTION_ITEM_BEGIN = 'EDITOR_UPDATE_COLLECTION_ITEM_BEGIN';
export const EDITOR_UPDATE_COLLECTION_ITEM_SUCCESS = 'EDITOR_UPDATE_COLLECTION_ITEM_SUCCESS';
export const EDITOR_UPDATE_COLLECTION_ITEM_FAILURE = 'EDITOR_UPDATE_COLLECTION_ITEM_FAILURE';
export const EDITOR_UPDATE_COLLECTION_ITEM_DISMISS_ERROR =
  'EDITOR_UPDATE_COLLECTION_ITEM_DISMISS_ERROR';
export const EDITOR_CREATE_COLLECTION_CONSTRAINT_BEGIN =
  'EDITOR_CREATE_COLLECTION_CONSTRAINT_BEGIN';
export const EDITOR_CREATE_COLLECTION_CONSTRAINT_SUCCESS =
  'EDITOR_CREATE_COLLECTION_CONSTRAINT_SUCCESS';
export const EDITOR_CREATE_COLLECTION_CONSTRAINT_FAILURE =
  'EDITOR_CREATE_COLLECTION_CONSTRAINT_FAILURE';
export const EDITOR_CREATE_COLLECTION_CONSTRAINT_DISMISS_ERROR =
  'EDITOR_CREATE_COLLECTION_CONSTRAINT_DISMISS_ERROR';
export const EDITOR_UPDATE_CONSTRAINT_OF_COLLECTION_BEGIN =
  'EDITOR_UPDATE_CONSTRAINT_OF_COLLECTION_BEGIN';
export const EDITOR_UPDATE_CONSTRAINT_OF_COLLECTION_SUCCESS =
  'EDITOR_UPDATE_CONSTRAINT_OF_COLLECTION_SUCCESS';
export const EDITOR_UPDATE_CONSTRAINT_OF_COLLECTION_FAILURE =
  'EDITOR_UPDATE_CONSTRAINT_OF_COLLECTION_FAILURE';
export const EDITOR_UPDATE_CONSTRAINT_OF_COLLECTION_DISMISS_ERROR =
  'EDITOR_UPDATE_CONSTRAINT_OF_COLLECTION_DISMISS_ERROR';
export const EDITOR_DELETE_COLLECTION_CONSTRAINT_BEGIN =
  'EDITOR_DELETE_COLLECTION_CONSTRAINT_BEGIN';
export const EDITOR_DELETE_COLLECTION_CONSTRAINT_SUCCESS =
  'EDITOR_DELETE_COLLECTION_CONSTRAINT_SUCCESS';
export const EDITOR_DELETE_COLLECTION_CONSTRAINT_FAILURE =
  'EDITOR_DELETE_COLLECTION_CONSTRAINT_FAILURE';
export const EDITOR_DELETE_COLLECTION_CONSTRAINT_DISMISS_ERROR =
  'EDITOR_DELETE_COLLECTION_CONSTRAINT_DISMISS_ERROR';
export const EDITOR_ADD_RULE_TO_COLLECTION_BEGIN = 'EDITOR_ADD_RULE_TO_COLLECTION_BEGIN';
export const EDITOR_ADD_RULE_TO_COLLECTION_SUCCESS = 'EDITOR_ADD_RULE_TO_COLLECTION_SUCCESS';
export const EDITOR_ADD_RULE_TO_COLLECTION_FAILURE = 'EDITOR_ADD_RULE_TO_COLLECTION_FAILURE';
export const EDITOR_ADD_RULE_TO_COLLECTION_DISMISS_ERROR =
  'EDITOR_ADD_RULE_TO_COLLECTION_DISMISS_ERROR';
export const EDITOR_DELETE_ASSET_BEGIN = 'EDITOR_DELETE_ASSET_BEGIN';
export const EDITOR_DELETE_ASSET_SUCCESS = 'EDITOR_DELETE_ASSET_SUCCESS';
export const EDITOR_DELETE_ASSET_FAILURE = 'EDITOR_DELETE_ASSET_FAILURE';
export const EDITOR_DELETE_ASSET_DISMISS_ERROR = 'EDITOR_DELETE_ASSET_DISMISS_ERROR';
export const EDITOR_DELETE_SNIPPET_BEGIN = 'EDITOR_DELETE_SNIPPET_BEGIN';
export const EDITOR_DELETE_SNIPPET_SUCCESS = 'EDITOR_DELETE_SNIPPET_SUCCESS';
export const EDITOR_DELETE_SNIPPET_FAILURE = 'EDITOR_DELETE_SNIPPET_FAILURE';
export const EDITOR_DELETE_SNIPPET_DISMISS_ERROR = 'EDITOR_DELETE_SNIPPET_DISMISS_ERROR';
export const EDITOR_DELETE_COLLECTION_VALIDATION_BEGIN =
  'EDITOR_DELETE_COLLECTION_VALIDATION_BEGIN';
export const EDITOR_DELETE_COLLECTION_VALIDATION_SUCCESS =
  'EDITOR_DELETE_COLLECTION_VALIDATION_SUCCESS';
export const EDITOR_DELETE_COLLECTION_VALIDATION_FAILURE =
  'EDITOR_DELETE_COLLECTION_VALIDATION_FAILURE';
export const EDITOR_DELETE_COLLECTION_VALIDATION_DISMISS_ERROR =
  'EDITOR_DELETE_COLLECTION_VALIDATION_DISMISS_ERROR';
export const EDITOR_UPLOAD_IMAGE_FROM_URL_BEGIN = 'EDITOR_UPLOAD_IMAGE_FROM_URL_BEGIN';
export const EDITOR_UPLOAD_IMAGE_FROM_URL_SUCCESS = 'EDITOR_UPLOAD_IMAGE_FROM_URL_SUCCESS';
export const EDITOR_UPLOAD_IMAGE_FROM_URL_FAILURE = 'EDITOR_UPLOAD_IMAGE_FROM_URL_FAILURE';
export const EDITOR_UPLOAD_IMAGE_FROM_URL_DISMISS_ERROR =
  'EDITOR_UPLOAD_IMAGE_FROM_URL_DISMISS_ERROR';
export const EDITOR_UPDATE_SNIPPET_BEGIN = 'EDITOR_UPDATE_SNIPPET_BEGIN';
export const EDITOR_UPDATE_SNIPPET_SUCCESS = 'EDITOR_UPDATE_SNIPPET_SUCCESS';
export const EDITOR_UPDATE_SNIPPET_FAILURE = 'EDITOR_UPDATE_SNIPPET_FAILURE';
export const EDITOR_UPDATE_SNIPPET_DISMISS_ERROR = 'EDITOR_UPDATE_SNIPPET_DISMISS_ERROR';
export const EDITOR_CREATE_SNIPPET_SNAPSHOT_BEGIN = 'EDITOR_CREATE_SNIPPET_SNAPSHOT_BEGIN';
export const EDITOR_CREATE_SNIPPET_SNAPSHOT_SUCCESS = 'EDITOR_CREATE_SNIPPET_SNAPSHOT_SUCCESS';
export const EDITOR_CREATE_SNIPPET_SNAPSHOT_FAILURE = 'EDITOR_CREATE_SNIPPET_SNAPSHOT_FAILURE';
export const EDITOR_CREATE_SNIPPET_SNAPSHOT_DISMISS_ERROR =
  'EDITOR_CREATE_SNIPPET_SNAPSHOT_DISMISS_ERROR';
export const EDITOR_LOAD_SNIPPET_SNAPSHOTS_BEGIN = 'EDITOR_LOAD_SNIPPET_SNAPSHOTS_BEGIN';
export const EDITOR_LOAD_SNIPPET_SNAPSHOTS_SUCCESS = 'EDITOR_LOAD_SNIPPET_SNAPSHOTS_SUCCESS';
export const EDITOR_LOAD_SNIPPET_SNAPSHOTS_FAILURE = 'EDITOR_LOAD_SNIPPET_SNAPSHOTS_FAILURE';
export const EDITOR_LOAD_SNIPPET_SNAPSHOTS_DISMISS_ERROR =
  'EDITOR_LOAD_SNIPPET_SNAPSHOTS_DISMISS_ERROR';
export const EDITOR_CLOSE_ITEM_DETAIL_PAGE = 'EDITOR_CLOSE_ITEM_DETAIL_PAGE';
export const EDITOR_OPEN_ITEM_DETAILS_PAGE_BEGIN = 'EDITOR_OPEN_ITEM_DETAILS_PAGE_BEGIN';
export const EDITOR_OPEN_ITEM_DETAILS_PAGE_SUCCESS = 'EDITOR_OPEN_ITEM_DETAILS_PAGE_SUCCESS';
export const EDITOR_OPEN_ITEM_DETAILS_PAGE_FAILURE = 'EDITOR_OPEN_ITEM_DETAILS_PAGE_FAILURE';
export const EDITOR_OPEN_ITEM_DETAILS_PAGE_DISMISS_ERROR =
  'EDITOR_OPEN_ITEM_DETAILS_PAGE_DISMISS_ERROR';
export const EDITOR_LOAD_EVENTS_BEGIN = 'EDITOR_LOAD_EVENTS_BEGIN';
export const EDITOR_LOAD_EVENTS_SUCCESS = 'EDITOR_LOAD_EVENTS_SUCCESS';
export const EDITOR_LOAD_EVENTS_FAILURE = 'EDITOR_LOAD_EVENTS_FAILURE';
export const EDITOR_LOAD_EVENTS_DISMISS_ERROR = 'EDITOR_LOAD_EVENTS_DISMISS_ERROR';
export const EDITOR_LOAD_LAYOUTS_BEGIN = 'EDITOR_LOAD_LAYOUTS_BEGIN';
export const EDITOR_LOAD_LAYOUTS_SUCCESS = 'EDITOR_LOAD_LAYOUTS_SUCCESS';
export const EDITOR_LOAD_LAYOUTS_FAILURE = 'EDITOR_LOAD_LAYOUTS_FAILURE';
export const EDITOR_LOAD_LAYOUTS_DISMISS_ERROR = 'EDITOR_LOAD_LAYOUTS_DISMISS_ERROR';
export const EDITOR_LOAD_EXTERNAL_APIS_BEGIN = 'EDITOR_LOAD_EXTERNAL_APIS_BEGIN';
export const EDITOR_LOAD_EXTERNAL_APIS_SUCCESS = 'EDITOR_LOAD_EXTERNAL_APIS_SUCCESS';
export const EDITOR_LOAD_EXTERNAL_APIS_FAILURE = 'EDITOR_LOAD_EXTERNAL_APIS_FAILURE';
export const EDITOR_LOAD_EXTERNAL_APIS_DISMISS_ERROR = 'EDITOR_LOAD_EXTERNAL_APIS_DISMISS_ERROR';
export const EDITOR_UPDATE_LATEST_PUBLISH_VERSION_BEGIN =
  'EDITOR_UPDATE_LATEST_PUBLISH_VERSION_BEGIN';
export const EDITOR_UPDATE_LATEST_PUBLISH_VERSION_SUCCESS =
  'EDITOR_UPDATE_LATEST_PUBLISH_VERSION_SUCCESS';
export const EDITOR_UPDATE_LATEST_PUBLISH_VERSION_FAILURE =
  'EDITOR_UPDATE_LATEST_PUBLISH_VERSION_FAILURE';
export const EDITOR_UPDATE_LATEST_PUBLISH_VERSION_DISMISS_ERROR =
  'EDITOR_UPDATE_LATEST_PUBLISH_VERSION_DISMISS_ERROR';
export const EDITOR_HIDE_BUILDER_LOADER = 'EDITOR_HIDE_BUILDER_LOADER';
export const EDITOR_SHOW_BUILDER_LOADER = 'EDITOR_SHOW_BUILDER_LOADER';
export const EDITOR_GET_PERMISSION_FLAGS_BEGIN = 'EDITOR_GET_PERMISSION_FLAGS_BEGIN';
export const EDITOR_GET_PERMISSION_FLAGS_SUCCESS = 'EDITOR_GET_PERMISSION_FLAGS_SUCCESS';
export const EDITOR_GET_PERMISSION_FLAGS_FAILURE = 'EDITOR_GET_PERMISSION_FLAGS_FAILURE';
export const EDITOR_GET_PERMISSION_FLAGS_DISMISS_ERROR = 'EDITOR_GET_PERMISSION_FLAGS_DISMISS_ERROR';
export const EDITOR_TOGGLE_DEBUG_MODE_BEGIN = 'EDITOR_TOGGLE_DEBUG_MODE_BEGIN';
export const EDITOR_TOGGLE_DEBUG_MODE_SUCCESS = 'EDITOR_TOGGLE_DEBUG_MODE_SUCCESS';
export const EDITOR_TOGGLE_DEBUG_MODE_FAILURE = 'EDITOR_TOGGLE_DEBUG_MODE_FAILURE';
export const EDITOR_TOGGLE_DEBUG_MODE_DISMISS_ERROR = 'EDITOR_TOGGLE_DEBUG_MODE_DISMISS_ERROR';
export const EDITOR_LOAD_USER_DETAILS_BEGIN = 'EDITOR_LOAD_USER_DETAILS_BEGIN';
export const EDITOR_LOAD_USER_DETAILS_SUCCESS = 'EDITOR_LOAD_USER_DETAILS_SUCCESS';
export const EDITOR_LOAD_USER_DETAILS_FAILURE = 'EDITOR_LOAD_USER_DETAILS_FAILURE';
export const EDITOR_LOAD_USER_DETAILS_DISMISS_ERROR = 'EDITOR_LOAD_USER_DETAILS_DISMISS_ERROR';
